export const NODE_TYPE = 'node' as const;
export const EDGE_TYPE = 'edge' as const;
export const GLOBAL_LOOPS_CONTAINER_TYPE = 'global-loops-container' as const;
export const DIAGRAM_CONTAINER_TYPE = 'diagram-container' as const;

export type ZoomDirection = 'IN' | 'OUT';

export type Direction = 'up' | 'down' | 'left' | 'right';

export const DIRECTION_KEYS: Record<string, Direction> = {
	ArrowUp: 'up',
	ArrowDown: 'down',
	ArrowLeft: 'left',
	ArrowRight: 'right',
};

export const ZOOM_KEYS: Record<string, ZoomDirection> = {
	'+': 'IN',
	'=': 'IN',
	'-': 'OUT',
	_: 'OUT',
};
